import React from "react"
import { HiChevronRight } from "react-icons/hi2"
import Slider from "react-slick"
import "slick-carousel/slick/slick.css"
import "slick-carousel/slick/slick-theme.css"
import {
  NextArrow,
  PrevArrow,
} from "@/components/CustomComponents/PromoCollection/icons"
import Image from "next/image"
import Link from "next/link"

export default function MobileSection({ collectionItems }) {
  const {
    heading = "",
    pageLink = "",
    leftImage = {},
    rightImage = {},
    bottomImage = {},
    description = "",
  } = collectionItems || {}
  const images = []
  images.push(leftImage, rightImage, bottomImage)

  const defaultSettings = {
    variableWidth: false,
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
  }
  return (
    <div
      className={`koh-mobile-row w-full flex flex-col justify-center min-w-0! overflow-hidden!`}
    >
      <h6 className="reveTxt-mobile flex">
        {heading}
        <span className="flex items-center">
          <HiChevronRight className="mt-1 w-5 h-5" />
        </span>
      </h6>

      <div className=" w-full !max-w-screen overflow-hidden">
        <Slider {...defaultSettings}>
          {images.map((img, index) => (
            <div key={index} className="relative">
              <Link href={pageLink}>
                <Image
                  src={img?.fields?.imageUrl}
                  alt={img?.fields?.altText}
                  width={521}
                  height={521}
                  className="w-full image-container object-cover block big-image"
                />
              </Link>
            </div>
          ))}
        </Slider>
        <div>
          <p className={`px-2 mt-7 koh-paras text-sm shopStatement`}>
            {description}
          </p>
        </div>
      </div>
    </div>
  )
}
